<template>
    <nav class='navigation-show'>
        <table>
            <tr>
                <td class='nav-list' style='width: 10em;' @click='scrollTo("legislatif")'>
                    Informations juridiques
                </td>
                <td colspan='3' style='height: 1em; transform: rotate(-90deg) translateX(-80%);'>
                    Navigation
                </td>
            </tr>
            <tr>
                <td class='nav-list' @click='scrollTo("glossaire")'>
                    Glossaire
                </td>
            </tr>
            <tr>
                <td class='nav-list' @click='scrollTo("tarifs")'>
                    Grille tarifaire
                </td>
            </tr>
            <tr>
                <td class='nav-list' @click='scrollTo("simulateur")'>
                    Simulateur
                </td>
            </tr>
            <tr>
                <td class='nav-list' @click='goWelcome()'>
                    Retour accueil
                </td>
            </tr>
        </table>
    </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Navigation',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {
        ...mapState('show', ['show']),
    },
    watch: {},
    created() {

    },
    methods: {
        scrollTo(divName) {
            window.document.getElementById(divName).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
            Object.keys(this.show).forEach((key) => {
                this.show[key] = false;
            })
            this.show[divName] = true;
        },
        goWelcome() {
            this.$router.push({ name: 'welcome' });
        },
    },
}
</script>

<style scoped>
.navigation-show {
    background-color: white;
    border: solid 1px #e2e2e2;
    border-left: none;
    border-radius: 0 5px 5px 0;
    position: fixed;
    top: 8em;
    left: -11em;
    width: auto;
    cursor: pointer;
    transition: all 0.25s ease-out;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05), 0 0 3px 0 rgba(0, 0, 0, 0.05);
}

.navigation-show:hover,
.navigation-show:focus {
    left: 0;
}

.nav-list {
    width: 8em;
}

.nav-list:hover {
    background-color: #eb5c2e;
    color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Simulateur/Navigation.vue